export default __webpack_public_path__ + "static/media/kenlo-house.9080f33c.svg";